import { css, Theme } from '@emotion/react'
import { alpha, buttonClasses, typographyClasses } from '@mui/material'

export const heading = css`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const checkbox = (theme: Theme) => css`
  margin: 0;

  .${typographyClasses.root} {
    margin-left: 8px;

    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    color: ${theme.colors.gray};
    user-select: none;
  }
`

export const mfaSettingsWrapper = css`
  display: flex;
  flex-direction: column;
  gap: 24px;
`

export const mfaInfoWrapper = (theme: Theme) => css`
  display: flex;
  flex-direction: column;
  gap: 5px;

  border: 1px solid ${theme.colors.backgroundOne};
  box-shadow: ${theme.boxShadows.small};
  border-radius: 16px;
  padding: 7px;
`

export const mfaInfoItem = (theme: Theme) => css`
  display: grid;
  grid-template-columns: 160px 1fr;
  gap: 8px;

  border-radius: 14px;
  padding: 14px;

  :nth-of-type(2n + 1) {
    background: ${theme.colors.backgroundFive};
  }
`

export const title = css`
  font-size: 14px;
  font-weight: 500;
`

export const value = css`
  font-size: 14px;
  font-weight: 400;
`

export const buttonsWrapper = (theme: Theme) => css`
  display: flex;
  column-gap: ${theme.spacing(2.5)};
`

export const dangerButton = (theme: Theme) => css`
  &.${buttonClasses.root} {
    color: ${theme.colors.red};
  }

  &.${buttonClasses.root}.${buttonClasses.disabled} {
    color: ${alpha(theme.colors.red, 0.6)};
  }
`
